import { Layout } from 'antd';
import React, { useRef } from 'react';
import TopHeader from './top_header';

const { Header, Content, Sider, Footer } = Layout;
const MasterLayout = ({children}) => {
    const contentRef = useRef();
    return (
        <>
            <Layout>
                <Layout>
                    <TopHeader />
                    <Content id="content-container" className='main-content' ref={contentRef}>
                        <div className='content'>
                            {children}
                        </div>
                    </Content>
                    {/* In Case Razer want footer */}
                    {/* <Footer id="footer-container" style={{background : '#282e41 '}}>                    
                        <div>
                            
                        </div>
                    </Footer> */}
                </Layout>
            </Layout>
        </>
    );
}

export default MasterLayout;